"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeploymentLineLegalNotice = exports.LEGAL_NOTICE_HOSTER_NAME = exports.LEGAL_NOTICE_HOSTER_DETAILS_ON_REQUEST = void 0;
exports.getDeploymentLineLegalPublisher = getDeploymentLineLegalPublisher;
const deploymentLineLegalNotice_1 = require("./deploymentLineLegalNotice");
const DEPLOYMENT_LINE_LEGAL_POSTAL = "2, Mail Anne-Catherine – 35000 Rennes";
const DEPLOYMENT_LINE_LEGAL_LECOFFREIO_DEFAULT = {
    publisherLegalName: "LEcoffre.io",
    publisherNameDefinitionSingular: "Lecoffre.io",
    partiesPluralUseLeArticle: true,
    publisherCguIntroAfterPartyName: `, ${DEPLOYMENT_LINE_LEGAL_POSTAL}, Numéro Siret 92747436100015, TVA intracommunautaire FR17927474361, et l'Internaute.`,
    contactEmail: "contact@lecoffre.io",
    supportEmail: "support@lecoffre.io",
    postalAddressLine: DEPLOYMENT_LINE_LEGAL_POSTAL,
    cguSiteHomeDeepLinkFrenchTail: "du LEcoffre.io",
    platformNameInPrivacyAndCookieText: "LECoffre.io",
    publisherFrenchExclusiveDeParticle: "de LEcoffre.io",
    legalNotice: (0, deploymentLineLegalNotice_1.getDeploymentLineLegalNotice)("lecoffreio"),
};
function getDeploymentLineLegalPublisher(_siteCode) {
    return DEPLOYMENT_LINE_LEGAL_LECOFFREIO_DEFAULT;
}
var deploymentLineLegalNotice_2 = require("./deploymentLineLegalNotice");
Object.defineProperty(exports, "LEGAL_NOTICE_HOSTER_DETAILS_ON_REQUEST", { enumerable: true, get: function () { return deploymentLineLegalNotice_2.LEGAL_NOTICE_HOSTER_DETAILS_ON_REQUEST; } });
Object.defineProperty(exports, "LEGAL_NOTICE_HOSTER_NAME", { enumerable: true, get: function () { return deploymentLineLegalNotice_2.LEGAL_NOTICE_HOSTER_NAME; } });
Object.defineProperty(exports, "getDeploymentLineLegalNotice", { enumerable: true, get: function () { return deploymentLineLegalNotice_2.getDeploymentLineLegalNotice; } });
